<template>
  <div class="absolute left-[0] z-[10] flex h-[100%] items-center">
    <div class="w-[160px] flex items-center rounded-[5px] bg-[#fff] searchInput"  id="headerSearch">
      <div class="flex justify-between items-center w-[100%] bg-[#F7F7F7] relative">
        <div class="w-[100%] bg-[#fff]">
          <input @focus="onfocus" @blur="leave" v-model="searchVal" style="outline:none;" @keydown.enter="enterEvent"
                 class="box-border rounded-[5px] text-[#000] bg-[#F7F7F7] w-[100%] h-[35px] py-[7px] pl-[15px] pr-[35px] text-[16px] placeholder:text-[14px]"
                 type="text" placeholder="搜文章、搜用户" />
        </div>
        <div class="cursor-pointer absolute right-[10px]" @click="search">
          <svg-icon icon-class="search" width="20px" height="21px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  data() {
    return {
      searchVal: '',
    }
  },
  methods: {
    search() {
      if (!this.searchVal) {
        return false
      }
      this.$router.push({
        path: `/forum/search`,
        query: { val: this.searchVal },
      })
      this.searchVal = ''
    },
    enterEvent(event) {
      if (event.keyCode == 13) {
        this.search()
      }
    },
    onfocus(e) {
      const searchEle = document.querySelectorAll('.searchInput')
      const outLeftControl = document.querySelector('.outLeftControl')
      // console.log(searchEle,outLeftControl)
      for (let i = 0; i < searchEle.length; i++) {
        searchEle[i].style.width = `429px`
        searchEle[i].style.height = '47px'
      }
    },
    leave() {
      const searchEle = document.querySelectorAll('.searchInput')
      for (let i = 0; i < searchEle.length; i++) {
        searchEle[i].style.width = `170px`
      }
    },
  },
}
</script>

<style scoped>
.searchInput {
  transition: width 0.2s;
  -webkit-transition: width 0.2s;
}
</style>